export const CALLOUTS = {
  note: { label: 'Note', icon: 'solar:info-circle-bold', box: 'border-[#1c4848]/15 bg-[#1c4848]/[0.04]', ink: 'text-[#1c4848]' },
  tip: { label: 'Tip', icon: 'solar:lightbulb-bolt-bold', box: 'border-emerald-700/15 bg-emerald-50', ink: 'text-emerald-800' },
  important: { label: 'Important', icon: 'solar:star-bold', box: 'border-[#a0833c]/30 bg-[#ecd79f]/25', ink: 'text-[#7a6128]' },
  warning: { label: 'Warning', icon: 'solar:danger-triangle-bold', box: 'border-red-700/15 bg-red-50', ink: 'text-red-800' },
};
